@if (total > 0) {
  <div class="component-container">
    <div class="test-count text-type-15">
      {{ total }}
      Offsite {{ total !== 1 ? 'Tests' : 'Test' }}
    </div>
    <div class="test-summary">
      <div class="open-tests">
        <mat-icon class="open-tests-icon" svgIcon="daily-report-material-testing"/>
        <div class="details-section" (click)="redirectToOffsiteTests()">
          <div class="label text-type-8">{{ openCount }} open</div>
        </div>
      </div>
      <div class="closed-tests">
        <mat-icon class="closed-tests-icon" svgIcon="closed-issues"/>
        <div class="details-section" (click)="redirectToOffsiteTests()">
          <div class="label text-type-8">{{ closedCount }} closed</div>
        </div>
      </div>
    </div>
  </div>
}
